import { getLanguage } from "../Managers/dataProvider";
import { BranchModel, ShiftModel, UserModel } from "../Managers/dataStructures";
import { DropMenuBranchSelection } from "../Managers/dropDownMenu";
import { ActivityIndicator } from "../Managers/utilityComponents";

export interface SPEmployeePanelProps {
  array_users: UserModel[];
  onChangeBranch: (branchItem: BranchModel) => void;
  onAddUser: (user: UserModel) => void;
  isActivityIndicator: boolean;
  isDisabled: boolean;
  array_branches: BranchModel[];
  selectedBranch: BranchModel;
}

export default function SPEmployeePanel(props: SPEmployeePanelProps) {
  const isEnglish = getLanguage();
  function onBranchSelect(item: BranchModel | ShiftModel) {
    props.onChangeBranch(item as BranchModel);
  }
  function onAddUser(item: UserModel) {
    props.onAddUser(item);
  }
  return (
    <div>
      <DropMenuBranchSelection
        onSelectItem={onBranchSelect}
        selectedItem={props.selectedBranch}
        isDisabled={props.isDisabled}
        array_branches={props.array_branches}
      />
      {props.isActivityIndicator ? (
        <div className="py-5 items-center flex flex-col">
          {ActivityIndicator(1)}
        </div>
      ) : props.array_users.length > 0 ? (
        <ul className="divide-y divide-gray-100">
          {props.array_users.map((x) =>
            CellEmployeePanel(x, onAddUser, props.isDisabled)
          )}
        </ul>
      ) : (
        <div className="flex h-[400px]">
          <p className="mx-auto my-auto text-sm text-gray-700 justify-center items-center">
            {isEnglish
              ? "No Available Employees"
              : "Keine Mitarbeiter vorhanden"}
          </p>
        </div>
      )}
    </div>
  );
}

function CellEmployeePanel(
  user: UserModel,
  onAddUser: (user: UserModel) => void,
  isDisabled: boolean
) {
  function onAdd() {
    onAddUser(user);
  }
  const isEnglish = getLanguage();
  return (
    <li
      className="flex items-center justify-between gap-x-6 py-5"
      key={user.user_id}
    >
      <div className="flex min-w-0 gap-x-4">
        <img
          className="h-12 w-12 flex-none rounded-full bg-gray-50"
          src={user.profile_pic_url}
          alt=""
        />
        <div className="min-w-0 flex-auto">
          <p className="text-sm font-semibold leading-6 text-gray-900">
            {user.first_name}
            <span
              className={
                "inline-flex ml-2 items-center rounded-md  px-2 py-1 text-xs font-medium  ring-1 ring-inset " +
                user.role.color_scheme
              }
            >
              {user.role.display_name}
            </span>
          </p>
          <p className="mt-1 truncate text-xs leading-5 text-gray-500">
            {user.employee_id}
          </p>
        </div>
      </div>
      {isDisabled === true ? null : (
        <a
          href={"#" + user.user_id}
          onClick={onAdd}
          className="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        >
          {isEnglish ? "Add" : "Hinzufügen"}
        </a>
      )}
    </li>
  );
}
